import { z } from 'zod';
import { Timestamp } from 'firebase/firestore';
import type { VacationEvent, VacationEventType, VacationEventSource } from './vacationEvent.types';

export const vacationEventTypeSchema = z.enum([
  'request_created',
  'request_opened',
  'manager_approved',
  'manager_rejected',
  'client_approved',
  'dp_approved',
  'dp_rejected',
  'dp_segment_approved',
  'dp_segment_rejected',
  'client_segment_approved',
  'client_segment_rejected',
  'sell_approved',
  'sell_rejected',
  'vacation_started',
  'vacation_completed',
  'direct_edit',
]);

export const vacationEventSourceSchema = z.enum(['user', 'system']);

export const vacationEventActorSchema = z
  .object({
    email: z.string().email().nullable().optional(),
    name: z.string().nullable().optional(),
  })
  .nullable()
  .optional();

export const vacationEventSchema = z.object({
  id: z.string(),
  requestId: z.string(),
  type: vacationEventTypeSchema,
  actor: vacationEventActorSchema,
  note: z.string().nullable().optional(),
  source: vacationEventSourceSchema,
  payload: z.record(z.unknown()).optional(),
  createdAt: z.union([
    z.instanceof(Date),
    z.instanceof(Timestamp),
    z.string(),
  ]),
});

export const createVacationEventSchema = z.object({
  type: vacationEventTypeSchema,
  actor: vacationEventActorSchema.nullable().optional(),
  note: z.string().max(500).nullable().optional(),
  source: vacationEventSourceSchema.default('user'),
  payload: z.record(z.unknown()).optional(),
});

export type CreateVacationEventInput = z.infer<typeof createVacationEventSchema>;
